module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Care — " + _vm._s(_vm.currencyFormat(_vm.value)) + "\n    ")]), _vm._v(" "), _c('modal-content')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6c3cb4a6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/reserving/day-one/lost/accordian-content/CareModal.vue
// module id = 1736
// module chunks = 0